module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page10",
      "title": "10"
    }
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he mood in the Operations Room was sombre, the atmosphere on the brink of oppressive. Whilst quiet conversations were taking place elsewhere, the three most important people in the room were now silent, their thoughts focused on events taking place hundreds of miles away. The scientist was the most agitated of the three, pacing up and down, going over and over in his mind the implications of what he, more than any other person, had set in train. The Air Chief Marshal and the Air Vice-Marshal stood still as the minutes ticked by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four times the telephone had rung, and each time the signals officer had reported the codeword for no result. Now the telephone rang again. The officer asked for confirmation and, when it came, his face lit up as he shouted out, ‘It’s Nigger!’ A wave of relief swept through the room. The scientist began to pump his arms up and down as the Air Chief Marshal went over to shake him vigorously by the hand. On the face of the Air Vice-Marshal, a man not given to extravagant displays of emotion, a rare smile appeared as he realised that his plan for the most extraordinary operation in his service’s history had at last come to fruition.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e181a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006_Prologue.vue
// module id = 72
// module chunks = 0